import React from 'react'
import { Wrapper } from './styled'

interface Props {
  imageUrl: string
}

export const MediaPlaceholder: React.FC<Props> = ({ imageUrl }) => {
  return (
    <Wrapper>
      <img src={imageUrl} alt='main' />
    </Wrapper>
  )
}
